import React, { Component } from 'react';
import { Modal } from 'react-bootstrap'
import styles from '../../Css/BackgroundListModal.module.css'
import axios from 'axios'

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';


function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "inline-block", background: "#fff" }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "inline-block", background: "#fff" }}
      onClick={onClick}
    />
  );
}
function SamplePrevArrow_1(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "inline-block", background: "#fff", left: "-19px" }}
      onClick={onClick}
    />
  );
}
function SampleNextArrow_1(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "inline-block", background: "#fff", right: "-19px" }}
      onClick={onClick}
    />
  );
}



class BackgroundListModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gifList: [],
      gifUrl: "",
      listcustomWall: "",
      accordianUuid: "bg",
      favourable: false,
      visualSelection: 'virtual_studio',
      wallList: []
    }
    this.wallFile = React.createRef()
  }

  componentDidMount = () => {
    this.setState({
      wallList: this.props.favBgList.concat(this.props.bgList)
    })

  }
  handleBackgroundGif = (imageId, imageCredit, gifUrls, favourite, image_url) => {
    if (this.props.applyType === 'VS') {
      this.setState({
        gifUrl: gifUrls,
        favourable: favourite
      })
      this.props.handleBackground(imageId, imageCredit, image_url)
    }
    else {
      this.setState({
        gifUrl: gifUrls,

      })
      this.props.setCustomWall(image_url)
    }
  }

  handleApply = () => {
    if (this.props.applyType === 'VS') {
      this.props.imageProcessing()
    }
    else {
      this.props.setShowBackgroundList(false)
    }
  }

  customWallselect = (wall_selected) => {
    this.setState({
      listcustomWall: wall_selected
    })
  }

  render() {
    return (
      <Modal
        show={this.props.showBackgroundList}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size='xl'
        centered>

        <Modal.Body>
          <section className={[styles['perfect-output-1'], 'p-0'].join(' ')}>
            <div className={[styles[''], 'container-fluid'].join(' ')}>
              <div className={[styles['choose-output'], 'row'].join(' ')}>
                <div className={[styles['bg-recomended-right'], 'col-md-7 col-12'].join(' ')}>
                  <h3>Choose  <span className={styles['border-bt']}>your <span className={styles['colored']}> Background</span></span></h3>
                  {this.state.gifUrl != '' ?
                    <img className="" src={this.state.gifUrl} />
                    :
                    <img className="" src={this.props.fileList[0] ? this.props.fileList[0].url : null} />
                  }

                  <div className={[styles['perfect-output-images'], 'row'].join(' ')}>
                    <p><span><a onClick={this.props.hideList}>Cancel</a></span> <a onClick={this.props.hideList}>Apply</a></p>
                  </div>
                </div>
                <div className={[styles['bg-recomended-area'], styles['custom-big'], 'col-md-5'].join(' ')}>
                  <h3><span className={styles['colored']}></span><span> Backgrounds</span> <img src="https://storage.googleapis.com/spyne-website/self-serve/down-blue.png" /></h3>
                  <div className={[styles['bg-recommended'], 'row m-0'].join(' ')}>
                    <ul className={[styles['bg-recomended-images'], ''].join(' ')}>
                      {this.props.applyType === 'VS' ?
                        this.props.bgList.map((e, i) => {
                          return (
                            <li key={i + "bg-list"} className={this.props.backgroundId === e.image_id ? [styles['solid-image'], styles['active'], styles['active-background-sec'], 'solid-image active'].join(' ') : [styles['solid-image'], styles['inactive-background-sec'], 'solid-image'].join(' ')} onClick={() => this.handleBackgroundGif(e.image_id, e.image_credit, e.gif_url, false, e.image_url)}>
                              <img className="" src={e.image_url} />
                              <span>{e.background_name} - {e.image_id}</span>
                              {this.props.isLoggedIn ?
                                        <p className={[styles['fav-icon'], styles['fav-icon-heart'], 'fav-icon'].join(' ')} onClick={() => this.props.handleCarsBgList(i, e.image_id)}>
                                            <i className={[styles['heart'], 'fa fa-heart'].join(' ')} aria-hidden="true"></i>
                                        </p>
                                        : null
                                    }
                            </li>
                          )
                        })
                        :
                        this.props.customWall.map((e, i) => {
                          return (
                            <li key={i + "custom-walls"} className={this.props.customWallselect == e.wall_png_url ? styles['active-background-sec'] : styles['inactive-background-sec']} onClick={() => this.handleBackgroundGif("", "", e.wall_png_url, false, e.wall_png_url)}>
                              <img className="" src={e.low_res_wall_url} />

                              <span>{e["wall_name"].substring(0, 10)}</span>
                            </li>
                          )
                        })

                      }

                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </Modal.Body>

      </Modal>
    );
  }
}

export default BackgroundListModal;